import script from "./PersonsPage.vue?vue&type=script&setup=true&lang=js"
export * from "./PersonsPage.vue?vue&type=script&setup=true&lang=js"

import "./PersonsPage.vue?vue&type=style&index=0&id=1adb5a80&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-1adb5a80"]])

export default __exports__